import { Table } from '@factorialco/deprecated-design-system'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import type Value from 'modules/custom_resources/store/models/customResources/Value'

import TableBodyRow from './_Row'

interface Props {
  schema: EmployeeCustomTablesSchemaFragment
  values?: Value[]
  attachableId: number
  currency: string
}

const TableBodyComponent = ({ schema, values = [], attachableId, currency }: Props) => (
  <Table.Body>
    {values.length === 0 && (
      <Table.Blank colSpan={schema.fields.length + 1} text={i18n.t('custom_tables.empty')} />
    )}
    {values.map((value, key) => (
      <TableBodyRow
        key={key}
        attachableId={attachableId}
        schema={schema}
        value={value}
        currency={currency}
      />
    ))}
  </Table.Body>
)

export default observer(TableBodyComponent)
